<template>
  <div id="staffNotificationHistoryModal" class="modal fade righToLeftModal" tabindex="-1" aria-labelledby="staffNotificationHistoryModal" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-body">
          <div class="notificationArea staff-notification-history-area">
            <div class="row justify-content-between">
              <div class="col-auto">
                <h5>Geçmiş Bildirimler</h5>
              </div>
              <div class="col-auto">
                <button type="button" class="close closebtn" aria-label="Kapat" data-dismiss="modal">
                  <span aria-hidden="true">
                    <img src="../../../public/src/images/sidebar-menu-close.svg" alt="sidebar-menu-close" />
                  </span>
                </button>
              </div>
            </div>

            <div class="staff-notification-history-content">
              <div v-if="loading" class="history-state text-muted">Yükleniyor...</div>

              <div v-else-if="notifications.length === 0" class="history-state text-muted">Aktif bildirim bulunamadı.</div>

              <div v-else>
                <section v-for="group in groupedNotifications" :key="group.label" class="notification-group">
                  <h6 class="notification-group-label">{{ group.label }}</h6>
                  <ul class="notificationNav">
                    <li
                      v-for="notification in group.items"
                      :key="notification.id"
                      class="nav-item"
                      @click="openNotification(notification)"
                    >
                      <a href="#" class="nav-link" @click.prevent>
                        <div class="row align-items-start">
                          <div class="col-auto">
                            <span class="notificationCircle" :class="circleClass(notification)">
                              <i :class="iconClass(notification)" aria-hidden="true" />
                            </span>
                          </div>
                          <div class="col pr-0">
                            <div class="notification-item-top">
                              <h5>{{ notification.name }}</h5>
                              <span class="notification-item-time">{{ formatRelativeDate(notification.startDate) }}</span>
                            </div>
                            <p class="text-wrap">{{ notification.subject }}</p>
                            <div class="notification-item-meta">
                              <span class="notification-type-badge" :class="badgeClass(notification)">{{ displayTypeLabel(notification) }}</span>
                              <span class="notification-item-dates">
                                {{ formatDate(notification.startDate) }} – {{ formatDate(notification.endDate) }}
                              </span>
                            </div>
                          </div>
                        </div>
                      </a>
                    </li>
                  </ul>
                </section>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import "moment/locale/tr";
import { formatApiDateTime, formatApiRelativeDateTime, parseApiDateTime } from "../../util/parseApiDateTime";

export default {
  name: "StaffNotificationHistoryModal",
  data() {
    return {
      notifications: [],
      loading: false,
    };
  },
  computed: {
    groupedNotifications() {
      const groups = new Map();
      const sorted = [...this.notifications].sort((a, b) => {
        const aDate = parseApiDateTime(a.startDate);
        const bDate = parseApiDateTime(b.startDate);
        return (bDate ? bDate.valueOf() : 0) - (aDate ? aDate.valueOf() : 0);
      });

      sorted.forEach((notification) => {
        const label = this.getGroupLabel(notification.startDate);
        if (!groups.has(label)) {
          groups.set(label, []);
        }
        groups.get(label).push(notification);
      });

      return Array.from(groups.entries()).map(([label, items]) => ({ label, items }));
    },
  },
  methods: {
    open() {
      this.loading = true;
      this.$store
        .dispatch("fetchStaffNotificationHistory")
        .then((response) => {
          this.notifications = response || [];
        })
        .finally(() => {
          this.loading = false;
          $("#staffNotificationHistoryModal").modal("show");
        });
    },
    openNotification(notification) {
      $("#staffNotificationHistoryModal").modal("hide");
      this.$emit("open-notification", [notification]);
    },
    formatDate(value) {
      return formatApiDateTime(value);
    },
    formatRelativeDate(value) {
      return formatApiRelativeDateTime(value);
    },
    getGroupLabel(value) {
      const date = parseApiDateTime(value);
      if (!date) return "Diğer";

      const now = moment().locale("tr");
      if (date.isAfter(now, "day")) {
        if (date.isSame(now, "month")) return "Yaklaşan";
        return date.format("MMMM YYYY");
      }
      if (date.isSame(now, "day")) return "Bugün";
      if (date.isSame(now.clone().subtract(1, "day"), "day")) return "Dün";
      if (date.isSame(now, "week")) return "Bu hafta";
      if (date.isSame(now, "month")) return "Bu ay";
      return date.format("MMMM YYYY");
    },
    displayTypeLabel(notification) {
      return notification.displayType === "MANDATORY" ? "Zorunlu" : "Bilgilendirme";
    },
    badgeClass(notification) {
      return notification.displayType === "MANDATORY" ? "is-mandatory" : "is-info";
    },
    circleClass(notification) {
      return notification.displayType === "MANDATORY" ? "high" : "medium";
    },
    iconClass(notification) {
      return notification.displayType === "MANDATORY" ? "fas fa-exclamation" : "fas fa-bell";
    },
  },
};
</script>

<style scoped>
.staff-notification-history-area {
  display: flex;
  flex-direction: column;
  height: 100vh;
}

.staff-notification-history-content {
  flex: 1;
  overflow-y: auto;
  padding-bottom: 24px;
}

.history-state {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  padding: 2rem 1.5rem;
  font-size: 0.9rem;
}

.notification-group-label {
  margin: 0;
  padding: 0.75rem 24px 0.35rem;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #9ca3af;
}

.notification-item-top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.5rem;
}

.notification-item-top h5 {
  margin-bottom: 0.25rem;
}

.notification-item-time {
  flex-shrink: 0;
  font-size: 0.72rem;
  font-weight: 500;
  color: #9ca3af;
  white-space: nowrap;
  line-height: 1.5;
}

.notification-item-meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.4rem;
  margin-top: 0.35rem;
}

.notification-type-badge {
  display: inline-block;
  padding: 0.1rem 0.45rem;
  border-radius: 999px;
  font-size: 0.68rem;
  font-weight: 600;
}

.notification-type-badge.is-mandatory {
  background: #fef2f2;
  color: #b91c1c;
}

.notification-type-badge.is-info {
  background: #eff6ff;
  color: #1d4ed8;
}

.notification-item-dates {
  font-size: 0.68rem;
  color: #9ca3af;
}

.notificationCircle i {
  font-size: 14px;
}
</style>
